import ActionTypes from "../constants/ActionTypes";

// import * as GoogleTagManager from "../utils/GoogleTagManager";
import GTM from "../utils/gtm";
import pubSub from "../utils/pubsub";
import cookie from "../utils/cookie";
import { enableBodyScroll } from "../utils/toggleBodyScroll";

let currentPage = "";

export const routeChange = store => next => action => {
    next(action);
    if (action.type === "@@router/LOCATION_CHANGE") {
        // Publish route change pubsub event
        pubSub.publish(action.type);

        const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`;

        if (!currentPage || currentPage !== nextPage) {
            // set previous page in redux and as cookie

            // set initial current page when not yet defined on first load
            if (!currentPage) {
                currentPage = nextPage;
            } else {
                // GA page send/tracking here
                GTM.logPageView();
            }

            cookie.set("auts_previous_page", currentPage, 31);

            store.dispatch({
                type: ActionTypes.SET_PREVIOUS_PAGE,
                previousPage: currentPage,
            });

            // close any open global modals
            store.dispatch({
                type: ActionTypes.CLOSE_ALL_MODALS,
            });

            // ensure body scrolling is renabled
            enableBodyScroll();

            currentPage = nextPage;
        }
    }
    return;
};

export default routeChange;
